import * as React from "react";
import SaveDialogLayout from "components/DialogLayout/SaveDialogLayout";
import repository from "client/repository";
import {DataBaseComponent, DataBaseComponentState} from "components/DataBaseComponent";
import {HubResource} from "../../client/resources/hubResource";
import {Text} from "../../components/form";
import {AdministratorRoleCallout} from "../../shared/AdministratorRoleCallout";

interface Props {
    hub: HubResource
    onChange: (hub: Partial<HubResource>) => void;
}

interface State extends DataBaseComponentState {
    oidcIdentityAudience?: string;
    oidcIdentityExternalId?: string;
}

class ChangeHubOidcIdentityDialog extends DataBaseComponent<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            oidcIdentityAudience: props.hub.OidcIdentityAudience,
            oidcIdentityExternalId: props.hub.OidcIdentityExternalId,
        };
    }

    render() {
        return <SaveDialogLayout title={`Hub OIDC Identity (${this.props.hub.DisplayName})`}
                                 onSaveClick={() => this.changeConfiguration()}
                                 errors={this.state.errors}
                                 busy={this.state.busy}>
            <AdministratorRoleCallout action="change a Hub's OIDC identity"/>
            <Text label="Audience"
                  value={this.state.oidcIdentityAudience}
                  onChange={oidcIdentityAudience => this.setState({oidcIdentityAudience})}/>
            <Text label="External ID"
                  value={this.state.oidcIdentityExternalId}
                  onChange={oidcIdentityExternalId => this.setState({oidcIdentityExternalId })}/>
        </SaveDialogLayout>;
    }

    private async changeConfiguration(): Promise<boolean> {
        return await this.doBusyTask(async () => {
            const request = {
                OidcIdentityAudience: this.state.oidcIdentityAudience,
                OidcIdentityExternalId: this.state.oidcIdentityExternalId
            };

            await repository.Hubs.changeOidcIdentity(this.props.hub.Id, request);
            window.location.reload(); // Force a reload so that Check Access is re-run
        });
    }


}

export default ChangeHubOidcIdentityDialog;
